import { render } from "./CookView.vue?vue&type=template&id=0debb4b0&scoped=true"
import script from "./CookView.vue?vue&type=script&lang=js"
export * from "./CookView.vue?vue&type=script&lang=js"

import "./CookView.vue?vue&type=style&index=0&id=0debb4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0debb4b0"]])

export default __exports__